import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getClassChineseFrm = ({ courseId, bookId }) =>
  httpClient.get(apis.getClassChineseFrm({ courseId, bookId }), {
    ignore: true,
    ignoreLoading: true,
  });

export const postClassChineseFrmConfirm = ({ courseId, bookId }) =>
  httpClient.post(apis.postClassChineseFrmConfirm(),
    { courseId, bookId },
    {
      ignore: true,
      ignoreLoading: true,
    }
  );
